<wl-image
  [imageSettings]="imageSettings"
  trackImpression="contentblock-impression"
  [trackImpressionInfo]="rendering"
  [trackImpressionContext]="context"
></wl-image>
